import { NavItem } from '@billy/design-system'

import { Product } from '@features/products/types/product'

// The ComboBox reports a selection by item value only, and product names aren't unique.
export const getItems = (products: Product[]): NavItem[] => {
  return products.map((product) => ({
    id: product.id,
    children: product.name,
    value: product.id,
  }))
}
